// Gallery configuration
// Folder ID is now stored in environment variables for security
// Set REACT_APP_GALLERY_FOLDER_ID in your .env file or Netlify environment variables

export const GALLERY_CONFIG = {
  // Falls back to empty string if not configured - the component will show an error message
  folderId: process.env.REACT_APP_GALLERY_FOLDER_ID || '',
};
